export const CATEGORIES = [
  {
    id: 'reading_room',
    name: 'Reading Room / Library',
    image: 'https://images.pexels.com/photos/5699635/pexels-photo-5699635.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940',
  },
  {
    id: 'home_theater',
    name: 'Home Theater',
    image: 'https://images.pexels.com/photos/109669/pexels-photo-109669.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940',
  },
  {
    id: 'private_dining',
    name: 'Private Dining',
    image: 'https://images.pexels.com/photos/1126689/pexels-photo-1126689.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940',
  },
  {
    id: 'home_gym',
    name: 'Home Gym',
    image: 'https://images.pexels.com/photos/7031709/pexels-photo-7031709.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940',
  },
  {
    id: 'game_room',
    name: 'Game Room',
    image: 'https://images.pexels.com/photos/7587474/pexels-photo-7587474.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940',
  },
  {
    id: 'creative_studio',
    name: 'Creative Studio',
    image: 'https://images.pexels.com/photos/6794933/pexels-photo-6794933.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940',
  },
  {
    id: 'backyard',
    name: 'Backyard / Garden',
    image: 'https://images.unsplash.com/photo-1558618666-fcd25c85cd64?w=800&auto=format&fit=crop',
  },
];

export const AMENITIES = [
  'WiFi',
  'Parking',
  'Air Conditioning',
  'Heating',
  'Kitchen Access',
  'Bathroom Access',
  'Sound System',
  'Projector',
  'Whiteboard',
  'Equipment Included',
  'Natural Light',
  'Private Entrance',
];

export const BOOKING_STATUS = {
  PENDING: 'pending',
  APPROVED: 'approved',
  REJECTED: 'rejected',
  CANCELLED: 'cancelled',
  CONFIRMED: 'confirmed',  // Payment completed, booking is confirmed
  COMPLETED: 'completed',  // Legacy - used after booking date passes
};

export const USER_ROLES = {
  GUEST: 'guest',
  HOST: 'host',
  ADMIN: 'admin',
};